/* ShapePower clone — interactions (idempotent) */
(function () {
  if (window.__spInit) return;
  window.__spInit = true;

  function init() {
    /* Burger mobile */
    document.querySelectorAll('[data-sp-burger]').forEach(function (btn) {
      if (btn.dataset.spBound === '1') return;
      btn.dataset.spBound = '1';
      btn.addEventListener('click', function () {
        var nav = document.querySelector('[data-sp-mobile-nav]');
        if (nav) nav.classList.toggle('is-open');
      });
    });

    /* Galerie produit : miniatures + dots + glissement (tactile, souris, clavier) */
    document.querySelectorAll('[data-sp-gallery]').forEach(function (gallery) {
      if (gallery.dataset.spBound === '1') return;
      gallery.dataset.spBound = '1';

      var slides = gallery.querySelectorAll('.sp-gallery__slide');
      var thumbs = gallery.querySelectorAll('.sp-gallery__thumbs button');
      var dots = gallery.querySelectorAll('.sp-gallery__dots button');
      var main = gallery.querySelector('.sp-gallery__main');
      var count = slides.length;
      var current = 0;
      if (!count) return;

      function goTo(i) {
        current = (i % count + count) % count; /* boucle dans les deux sens */
        slides.forEach(function (s, j) { s.classList.toggle('is-active', current === j); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', current === j); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', current === j); });
      }

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

      if (!main || count < 2) return;

      var SEUIL = 40; /* px de déplacement horizontal avant de changer d'image */
      var x0 = null, y0 = null;

      function debut(x, y) { x0 = x; y0 = y; }
      function fin(x, y) {
        if (x0 === null) return;
        var dx = x - x0, dy = y - y0;
        x0 = y0 = null;
        /* on ignore si le geste est plutôt vertical : c'est un scroll de page */
        if (Math.abs(dx) < SEUIL || Math.abs(dx) <= Math.abs(dy)) return;
        goTo(dx < 0 ? current + 1 : current - 1);
      }

      main.addEventListener('touchstart', function (e) {
        debut(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        fin(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
      }, { passive: true });

      main.addEventListener('mousedown', function (e) { debut(e.clientX, e.clientY); });
      main.addEventListener('mouseup', function (e) { fin(e.clientX, e.clientY); });
      main.addEventListener('mouseleave', function () { x0 = y0 = null; });
      main.addEventListener('dragstart', function (e) { e.preventDefault(); });

      main.setAttribute('tabindex', '0');
      main.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });
    });

    /* Le menu mobile se referme dès qu'on clique un lien (sinon il masque la cible de l'ancre) */
    document.querySelectorAll('[data-sp-mobile-nav] a').forEach(function (a) {
      if (a.dataset.spBound === '1') return;
      a.dataset.spBound = '1';
      a.addEventListener('click', function () {
        var nav = a.closest('[data-sp-mobile-nav]');
        if (nav) nav.classList.remove('is-open');
      });
    });

    /* Buy-box : variantes, prix, économie, barre collante */
    document.querySelectorAll('[data-sp-buybox]').forEach(function (box) {
      if (box.dataset.spBound === '1') return;
      box.dataset.spBound = '1';

      var blob = box.querySelector('[data-sp-variants]');
      var idInput = box.querySelector('[data-sp-variant-id]');
      var atc = box.querySelector('[data-sp-atc]');
      var selects = box.querySelectorAll('[data-sp-option]');
      var elPrice = box.querySelector('[data-sp-price-current]');
      var elCompare = box.querySelector('[data-sp-price-compare]');
      var elSave = box.querySelector('[data-sp-price-save]');

      if (blob && idInput && atc && selects.length) {
        var variants = [];
        try { variants = JSON.parse(blob.textContent); } catch (e) { variants = []; }
        var labelATC = atc.getAttribute('data-sp-atc-label') || atc.textContent.trim();
        var labelOut = atc.getAttribute('data-sp-soldout') || 'Esaurito';

        function montre(el, texte) {
          if (!el) return;
          if (texte) { el.textContent = texte; el.hidden = false; }
          else { el.textContent = ''; el.hidden = true; }
        }

        function majVariante() {
          var choix = Array.prototype.map.call(selects, function (s) { return s.value; });
          var v = null;
          for (var i = 0; i < variants.length; i++) {
            var o = variants[i].options || [];
            if (o.length === choix.length && o.every(function (val, j) { return val === choix[j]; })) { v = variants[i]; break; }
          }
          if (!v) {
            atc.disabled = true;
            atc.textContent = labelOut;
            return;
          }
          idInput.value = v.id;
          if (elPrice) elPrice.textContent = v.price;
          montre(elCompare, v.compare);
          montre(elSave, v.save ? (elSave.getAttribute('data-sp-save-label') || 'Risparmi') + ' ' + v.save : null);
          atc.disabled = !v.available;
          atc.textContent = v.available ? labelATC : labelOut;
        }

        selects.forEach(function (s) { s.addEventListener('change', majVariante); });
        majVariante();
      }

      /* Barre collante : visible quand le bouton principal quitte l'écran */
      var bar = document.querySelector('[data-sp-stickybar]');
      if (bar && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.hidden = entries[0].isIntersecting;
        }, { rootMargin: '0px 0px -80px 0px' }).observe(atc);

        var btn = bar.querySelector('[data-sp-sticky-atc]');
        if (btn) btn.addEventListener('click', function () { atc.click(); });
      }

      /* Pastille flottante : ramène à la buy-box */
      var jump = document.querySelector('[data-sp-jump]');
      if (jump && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          /* inutile de la montrer quand le produit est déjà à l'écran */
          jump.hidden = e.isIntersecting;
          /* flèche vers le haut si la buy-box est au-dessus du viewport */
          jump.classList.toggle('is-up', e.boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(box);

        jump.addEventListener('click', function (ev) {
          ev.preventDefault();
          box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

        /* on la remonte quand la barre d'achat occupe le bas de l'écran */
        if (bar && 'MutationObserver' in window) {
          var sync = function () { jump.classList.toggle('is-raised', !bar.hidden); };
          new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['hidden'] });
          sync();
        }
      }
    });

    /* Sélecteur de quantité */
    document.querySelectorAll('[data-sp-qty]').forEach(function (qty) {
      if (qty.dataset.spBound === '1') return;
      qty.dataset.spBound = '1';
      var input = qty.querySelector('input');
      qty.querySelector('[data-sp-qty-minus]').addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
      qty.querySelector('[data-sp-qty-plus]').addEventListener('click', function () {
        input.value = parseInt(input.value || '1', 10) + 1;
      });
    });

    /* Modale guide des tailles */
    document.querySelectorAll('[data-sp-gt-open]').forEach(function (btn) {
      if (btn.dataset.spBound === '1') return;
      btn.dataset.spBound = '1';
      btn.addEventListener('click', function () {
        var overlay = document.getElementById(btn.getAttribute('data-sp-gt-open'));
        if (overlay) overlay.classList.add('is-open');
      });
    });
    document.querySelectorAll('[data-sp-gt-overlay]').forEach(function (overlay) {
      if (overlay.dataset.spBound === '1') return;
      overlay.dataset.spBound = '1';
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.closest('[data-sp-gt-close]')) overlay.classList.remove('is-open');
      });
    });
  }

  /* Écouteur global : une seule fois, hors init() */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.sp-gt-overlay.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* L'éditeur de thème réinjecte le HTML des sections : on rebranche.
     Les garde-fous data-sp-bound empêchent tout double branchement. */
  document.addEventListener('shopify:section:load', init);
})();
